
import { Injectable } from '@angular/core';

import { Department } from '../shared/models/department.model';

@Injectable() export class Storage {

 constructor() {}

 public getDepartments(key: string): Department[] {
    let departments = localStorage.getItem(key);
    return JSON.parse(departments);
 }

 public setDepartments(key: string, departments: Department[])  {
     localStorage.removeItem(key);
     let jsonDepartments = JSON.stringify(departments);
     localStorage.setItem(key, jsonDepartments);
 }

 public clearDepartments(key: string) {
     localStorage.removeItem(key);
 }

}